export const STATIC_SESSION = {
  banner_message: '',
  current_account_id: 2074697,
  email: 'flash.slothmore@zapier.com',
  first_name: 'Flash',
  has_activated: true,
  has_active_zaps: true,
  has_signed_up: true,
  id: 10768828,
  identity: -2132949854,
  is_developer: true,
  is_expert: false,
  is_high_value: true,
  is_logged_in: true,
  is_staff: true,
  is_temporary: false,
  last_login: '2022-10-24T00:36:53+00:00',
  last_name: 'Slothmore',
  organizations: [1],
  photo_url: 'https://cdn.zappy.app/bf7a4f6fe39b2b0f80ab567ecaa5ebc7.png',
  primary_organization: 1,
  signup: '2021-08-22T19:55:44+00:00',
  since_signup: '1 year, 2 months',
  timezone: 'America/Los_Angeles',
  user_id: 10774996,
  username: 'flash.slothmore@zapier.com',
  roles: [
    { account_id: 2074697, role: 'member' },
    { account_id: 10766258, role: 'owner' },
  ],
};

export const STATIC_EXTENDED_SESSION = {
  ...STATIC_SESSION,
  current_account_role: 'member',
};

export const DEFAULT_SESSION = {
  banner_message: '',
  current_account_id: null,
  email: '',
  first_name: '',
  has_activated: false,
  has_active_zaps: false,
  has_signed_up: false,
  identity: null,
  is_developer: false,
  is_expert: false,
  is_high_value: false,
  is_logged_in: false,
  is_staff: false,
  is_temporary: false,
  last_login: '',
  last_name: '',
  organizations: [null],
  photo_url: '',
  primary_organization: null,
  signup: '',
  since_signup: '',
  timezone: '',
  username: '',
};
